<template>
  <div class="flex flex-col items-stretch gap-2">
    <JoszakiButton type="info" inverted outline @click="goToRating">
      {{ $t("profileAction.rateMate") }}
    </JoszakiButton>
    <JoszakiButton type="danger" inverted outline @click="reportPerson">
      {{ $t("profileAction.reportMate") }}
    </JoszakiButton>
  </div>
</template>

<script>
export default {
  props: {
    person: {
      type: Object,
      required: true,
    },
  },
  methods: {
    goToRating() {
      this.$router.push(
        this.localePath({
          name: "professionalRatingPage",
          params: {
            professionalSeoName: this.person.seoName,
          },
        })
      );
    },
    reportPerson() {
      this.$nuxt.$emit("report-person");
    },
  },
};
</script>
